<template>
  <div>
    <div class="flex justify-between items-center mb-4">
        <h1 class="text-4xl font-bold tracking-tight text-gray-600">Studiesteder</h1>
        <div class="flex itens-center">
          <search-input v-model="search"></search-input>
          <router-link class="ml-4 btn btn-primary" to="studiesteder/opprett">Nytt studiested</router-link>
          <a href="#" @click.prevent="onDelete" class="ml-4 btn" v-if="selected.length > 0">
            <font-awesome-icon :icon="['far', 'trash']" />
          </a>
        </div>
      </div>
    <panel>
      <data-table
        :headers="headers"
        :items="universities"
        :search="search"
        :showSelect="true"
        v-model="selected"
        identifier="universityId"
        @click="onClick">
      </data-table>
    </panel>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'university-list',
  data () {
    return {
      search: '',
      selected: [],
      headers: [
        { text: 'Navn', align: 'left', value: 'name' }
      ],
      universities: [],
    }
  },
  methods: {
    onClick (university) {
      this.$router.push('/af/studiesteder/' + university.universityId)
    },
    async onDelete () {
      for (let i = 0; i < this.selected.length; i++) {
        await api.af.deleteUniversity(this.selected[i].universityId)
      }
      this.$toasted.show(`${ this.selected.length } studiested${ this.selected.length > 1 ? 'er' : '' } slettet!`)
      this.universities = await api.af.getUniversities()
    }
  },
  async created () {
    this.universities = await api.af.getUniversities()
  }
}
</script>